import * as React from "react";

export const IconOutgoingMail = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3265_2327)">
      <path
        d="M15.4165 9.16699C15.5582 9.16699 15.6998 9.17533 15.8332 9.19199V5.72533C15.8332 4.86699 15.1332 4.16699 14.2748 4.16699L3.22484 4.16699C2.3665 4.16699 1.6665 4.86699 1.6665 5.72533L1.6665 14.2753C1.6665 15.1337 2.3665 15.8337 3.22484 15.8337L11.3332 15.8337C11.0165 15.2087 10.8332 14.5003 10.8332 13.7503C10.8332 11.217 12.8832 9.16699 15.4165 9.16699ZM8.6665 10.8337L3.33317 7.65866L3.33317 5.83366H3.52484L8.67484 8.90033L13.9498 5.83366H14.1665V7.63366L8.6665 10.8337Z"
        fill="currentColor"
      />
      <path
        d="M15.8333 10.834L14.6583 12.009L15.975 13.334H12.5V15.0007H15.975L14.6583 16.3257L15.8333 17.5007L19.1667 14.1673L15.8333 10.834Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3265_2327">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
